import {Action} from '@ngrx/store';
import {IInsurerItem} from '../../../models/insurer.model';

export enum InsurerActionsType {
  load = '[Insurer] Load insurers',
}

export class InsurerLoadAction implements Action {

  readonly type = InsurerActionsType.load;

  constructor(public payload: {insurers: IInsurerItem[]}) {}

}

export type InsurerActions = InsurerLoadAction;
